export const validation = {
  title: { required: true },
  titleMaxChar: 30,
  paragraphMaxChar: 300,
  buttons: {
    min: 0,
    max: 2
  }
}
